import React from 'react';

export default function MainInput(props) {
  const [focused, setFocused] = React.useState(false);

  const getType = () => props.type ?? 'text';

  return (
    <div className={`flex flex-col w-full mb-0 ${props.className || ''}`}>

      {props.fieldName && (
        <label className="font-semibold text-sm mb-2 text-darkGray">
          {props.fieldName}
        </label>
      )}

      <div
        className={`
          flex items-center w-full h-11 px-3 rounded-lg bg-white border transition
          ${focused ? 'ring-1 ring-mediumGray' : ''}
          ${props.error ? '!border-red ring-0' : ''}
        `}
      >
        <input
          className="w-full h-full bg-transparent outline-none text-sm text-mediumGray placeholder-mediumGray"
          type={getType()}
          value={props.value}
          placeholder={props.placeholder}
          onChange={(ev) => props.onChange(ev.target.value)}
          onFocus={() => setFocused(true)}
          onBlur={() => setFocused(false)}
        />
      </div>

      {props.error && props.errorMessage && (
        <p className="text-red mt-1 text-xs font-semibold">
          {props.errorMessage}
        </p>
      )}
    </div>
  );
}
